// extracted by mini-css-extract-plugin
module.exports = {"g-base-layout":"base-layout_g-base-layout__14xYs","main":"base-layout_main__15Ntj"};